'use client';

import { useTranslations } from 'next-intl';
import { FeatureDetailContent } from './FeatureDetailContent';
import {
    Globe,
    Layout,
    Settings,
    Search,
    Users,
    TrendingUp
} from 'lucide-react';

export function ReplicatingWebsiteContent() {
    const t = useTranslations('replicatingWebsite');

    const features = [
        {
            icon: Globe,
            title: t('features.step1.title'),
            description: t('features.step1.description'),
        },
        {
            icon: Layout,
            title: t('features.step2.title'),
            description: t('features.step2.description'),
        },
        {
            icon: Settings,
            title: t('features.step3.title'),
            description: t('features.step3.description'),
        },
        {
            icon: Search,
            title: t('features.step4.title'),
            description: t('features.step4.description'),
        },
        {
            icon: Users,
            title: t('features.step5.title'),
            description: t('features.step5.description'),
        },
        {
            icon: TrendingUp,
            title: t('features.step6.title'),
            description: t('features.step6.description'),
        },
    ];

    // Get benefits list from translations, ensuring it's always an array
    const benefitsRaw = t.raw('benefits.list');
    const benefits = Array.isArray(benefitsRaw) ? benefitsRaw : (benefitsRaw ? [benefitsRaw] : []);

    return (
        <FeatureDetailContent
            pageKey="replicating-website"
            translationNamespace="replicatingWebsite"
            features={features}
            benefits={benefits}
            ctaIcon={Globe}
            showWhatIsBitcoin={false}
            introImageSrc="/images/features/replicating-website.webp"
            introImageAlt={t('intro.imageAlt') || 'Replicating Website in MLM Software'}
            introParagraphKeys={['paragraph2', 'paragraph3']}
            introSectionHeadingPage="replicating-website"
            introSectionHeadingTitle={t('intro.sectionHeadingTitle') || 'About Replicating Website'}
            introSectionHeadingPill={t('intro.sectionHeadingPill') || 'Replicating Website'}
            useLocaleContent={true}
        />
    );
}

